/**
 * Returns the first argument it receives.
 */
export default function identityFunc(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/identityFunc.mjs
// module id = 2330
// module chunks = 4